import {type Writable, writable} from "svelte/store";

export const templateDocuments:Writable<any> = writable([])